import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import * as authenticationActions from '../actions/authentication.actions';

import { JwtUser } from '@models/authentication/jwt-user.model';

export const authenticationFeatureKey = 'authentication';

export interface AuthenticationState {
  authUser: JwtUser;
  isLoading: boolean;
  error: any;
}

export const initialAuthState: AuthenticationState = {
  authUser: null,
  isLoading: false,
  error: null
};

const authenticationReducer = createReducer(
  initialAuthState,

  // Login
  on(authenticationActions.login, state => ({...state, isLoading: true})),
  on(authenticationActions.loginSuccess, (state, {data}) => ({...state, authUser: data, isLoading: false})),
  on(authenticationActions.loginFailed, (state, {error}) => ({...state, error, isLoading: false})),

  // Refresh Token
  on(authenticationActions.refreshToken, state => ({...state, isLoading: true})),
  on(authenticationActions.refreshTokenSuccess, (state, {data}) => ({...state, authUser: data, isLoading: false})),
  on(authenticationActions.refreshTokenFailed, (state, {error}) => ({...state, error, isLoading: false})),

  // Logout
  on(authenticationActions.logout, state => ({...state, isLoading: true})),
  on(authenticationActions.logoutSuccess, state => ({...state, authUser: null, isLoading: false})),
  on(authenticationActions.logoutFailed, (state, {error}) => ({...state, error, isLoading: false})),

  // Forgot Password
  on(authenticationActions.forgotPassword, state => ({...state, isLoading: true})),
  on(authenticationActions.forgotPasswordSuccess, state => ({...state, isLoading: false})),
  on(authenticationActions.forgotPasswordFailed, (state, {error}) => ({...state, error, isLoading: false})),

  // Reset Password
  on(authenticationActions.resetPassword, state => ({...state, isLoading: true})),
  on(authenticationActions.resetPasswordSuccess, state => ({...state, isLoading: false})),
  on(authenticationActions.resetPasswordFailed, (state, {error}) => ({...state, error, isLoading: false}))
);

export function reducer(state: AuthenticationState | undefined, action: Action) {
  return authenticationReducer(state, action);
}

export const getAuthState = createFeatureSelector<AuthenticationState>(authenticationFeatureKey);
export const getAuthUser = createSelector(getAuthState, (state: AuthenticationState) => state.authUser);
export const isLoading = createSelector(getAuthState, (state: AuthenticationState) => state.isLoading);
